export const SENTRY_IGNORABLE_STRIPE_ERRORS = [
  "card_not_supported",
  "card_declined",
  "insufficient_funds",
  "incorrect_number",
  "incorrect_cvc"
];
